// 네이버 데이터랩 추세가 옛 확장 때문에 빈칸이면 조용히 두지 않고 크게 알린다(D-153 · saram 조건 5 · cpl-x3-naverkeyaes-1).
// 새 확장은 추세를 서버(/api/datalabTrend · 서버 도구)로 받고 메시지에 trendVia:'server' 표지를 싣는다 — 표지가 없으면 옛 확장.
// 열쇠를 저장한 적 없으면 원래 빈칸이 맞고, 옛 확장이어도 추세가 왔으면(날값이 아직 남은 회사) 알릴 것 없다. 이 파일은 의존성이 없다(단위 시험이 그대로 올린다).
export const DATALAB_OLD_EXT_NOTICE = '네이버 추세는 새 확장에서 나옵니다 — 확장을 업데이트해 주세요. (지금 확장으로는 검색트렌드 칸이 비어 있습니다)';

export function datalabTrendNotice({ hasDatalabKey, trendVia, keywordTrend } = {}) {
    if (!hasDatalabKey || trendVia === 'server') return '';
    if (Array.isArray(keywordTrend) && keywordTrend.length) return '';
    return DATALAB_OLD_EXT_NOTICE;
}
